import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Badge,
  Button,
  Collapse,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  addSelectedFilter,
  deleteSelectedFilter,
} from '../../actions/Files';

import { slugify } from '../../helpers';
import { getFileAccessIcon } from '../../helpers/Files';

import FiltersResetButton from './FiltersResetButton';

const getVisibility = (key, intl) => {
  if (`${key}` === '1') {
    return intl.formatMessage({ defaultMessage: 'Open' });
  }
  return intl.formatMessage({ defaultMessage: 'Restricted' });
};

class FiltersFileVisibility extends Component {
  constructor(props) {
    super(props);

    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  handleChangeFilter(e) {
    const {
      checked,
      value,
    } = e.target;
    const {
      intl,
      filters,
      handleChangeFilters,
      addFilter,
      removeFilter,
    } = this.props;
    let { visibility: newSelected } = filters;
    if (checked) {
      newSelected.push(value);
      addFilter({
        type: 'visibility',
        key: `${value}`,
        label: getVisibility(value, intl),
        title: intl.formatMessage({ defaultMessage: 'Visibility' }),
      });
    } else {
      newSelected = newSelected.filter(s => (s !== `${value}`));
      removeFilter('visibility', value);
    }
    handleChangeFilters({ visibility: newSelected });
  }

  handleReset() {
    const {
      handleChangeFilters,
      clearSelectedFilters,
    } = this.props;
    handleChangeFilters({ visibility: [] });
    clearSelectedFilters('visibility');
  }

  render() {
    const {
      intl,
      isOpen,
      availableFilters,
      filters,
      handleToggleFilter,
      prefix,
    } = this.props;
    const selected = filters.visibility;

    if (availableFilters.length === 0) {
      return null;
    }

    return (
      <div className="files-filter file-visibility-filter">
        <div className="filter-header">
          <Button onClick={handleToggleFilter} className="filter-title">
            <i className={`fal fa-angle-${isOpen ? 'up' : 'down'}`} />
            <span>{intl.formatMessage({ defaultMessage: 'File visibility' })}</span>
            {' '}
            {selected.length > 0 && (
              <Badge color="primary">
                {selected.length}
              </Badge>
            )}
          </Button>
          {selected.length > 0 && (
            <FiltersResetButton
              handleReset={this.handleReset}
            />
          )}
        </div>
        <Collapse
          isOpen={isOpen}
          className="filter-body"
        >
          <div className="filter-form file-visibility-filter-form">
            {availableFilters.map(ft => (
              <FormGroup key={`filevisibility-${slugify(ft.key)}`}>
                <Label for={`${prefix}checkFileVisibility-${slugify(ft.key)}`} check>
                  <Input
                    type="checkbox"
                    name="fileVisibility"
                    id={`${prefix}checkFileVisibility-${slugify(ft.key)}`}
                    className="input-check check-s"
                    value={`${ft.key}`}
                    checked={selected.find(s => (s === `${ft.key}`)) || false}
                    onChange={this.handleChangeFilter}
                  />
                  {' '}
                  <span>
                    <i className={`fas ${getFileAccessIcon({ public: ft.key })}`} />
                    {' '}
                    {getVisibility(ft.key, intl)}
                  </span>
                </Label>
              </FormGroup>
            ))}
          </div>
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  statuses: state.Files.statuses,
  filters: props.customFilters || state.Files.filters,
});

const mapDispatchToProps = (dispatch, props) => ({
  addFilter: props.customAddFilter || ((filter) => {
    dispatch(addSelectedFilter(filter));
  }),
  removeFilter: props.customRemoveFilter || ((filterType, filterKey) => {
    dispatch(deleteSelectedFilter(filterType, filterKey));
  }),
  clearSelectedFilters: props.customClearSelectedFilters || ((filterType) => {
    dispatch(deleteSelectedFilter(filterType, null));
  }),
});

FiltersFileVisibility.propTypes = {
  intl: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  clearSelectedFilters: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  availableFilters: PropTypes.array.isRequired,
  handleChangeFilters: PropTypes.func.isRequired,
  handleToggleFilter: PropTypes.func.isRequired,
  prefix: PropTypes.string,
};

FiltersFileVisibility.defaultProps = {
  prefix: '',
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(FiltersFileVisibility));
